import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    window.gtag("config", "G-RRGHPBWLWG", {
      page_path: location.pathname + location.search,
    });
  }, [location]);

  return null;
}

export default AnalyticsTracker;